module.exports = __webpack_public_path__ + "img/renwu.d19d49c9.png";